export const selectedUser = (state) => state.adminUsersReducer.selectedRecord;
export const selectedResetPasswordUser = (state) =>
  state.adminUsersReducer.resetPasswordUserId;
export const adminUsersData = (state) => state.adminUsersReducer;
